import React from 'react';

import type { SimpleIconInterface } from './icon-utils';
import { SimpleIcon } from './icon-utils';

export function RadioUnselectedIcon({
  className,
  fill,
  height,
  width,
}: SimpleIconInterface): JSX.Element {
  return (
    <SimpleIcon
      className={className}
      height={height ?? 18}
      viewBoxDimensions="0 0 18 18"
      width={width ?? 18}
    >
      <g fill={fill ?? 'currentColor'}>
        <path
          d="M9 16.5c4.142 0 7.5-3.358 7.5-7.5 0-4.142-3.358-7.5-7.5-7.5-4.142 0-7.5 3.358-7.5 7.5 0 4.142 3.358 7.5 7.5 7.5zM9 18c-4.97 0-9-4.03-9-9s4.03-9 9-9 9 4.03 9 9-4.03 9-9 9z"
          transform="translate(-1161 -620) translate(1161 620)"
        />
      </g>
    </SimpleIcon>
  );
}
